import { ColoursObj } from '@eventr/common-storybook'
import { useEffect, useMemo } from 'react'
import { Marker } from 'react-map-gl/maplibre'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../../state/bound.store'
import { useLiveLocationStore } from '../../../../state/liveLocationState/liveLocation.store'
import { useEphemeralStore } from '../../../../state/useEphemeralStore'
import { MemberProfilePic } from '../../../team/MemberProfilePic'
import LocationDot from '../components/locationDot'
import getTeamMemberLocations from '../functions/getTeamMemberLocations'
import { LngLatLabelledAppUser } from '../interfaces/locationLabelledObject'

export default function TeamMemberLocationMarkers() {
    const { selectedItineraryUsers, getCurrentUser } = useBoundStore(
        useShallow((s) => {
            return {
                selectedItineraryUsers: s.selectedItineraryUsers,
                getCurrentUser: s.getCurrentUser,
            }
        })
    )

    const {
        selectLngLatLabelledTeamMember,
        selectedLngLatLabelledTeamMember,
        mapFlyTo,
    } = useEphemeralStore(
        useShallow((s) => {
            return {
                selectLngLatLabelledTeamMember:
                    s.selectLngLatLabelledTeamMember,
                selectedLngLatLabelledTeamMember:
                    s.selectedLngLatLabelledTeamMember,
                mapFlyTo: s.mapFlyTo,
            }
        })
    )

    const liveLocations = useLiveLocationStore(
        useShallow((state) => state.liveLocations)
    )

    const teamMemberLocations: LngLatLabelledAppUser[] = useMemo(
        () =>
            getTeamMemberLocations(
                liveLocations,
                selectedItineraryUsers(),
                getCurrentUser()
            ),
        [selectedItineraryUsers, liveLocations, getCurrentUser]
    )

    const onClick = (lngLatLabelledAppUser: LngLatLabelledAppUser) => {
        selectLngLatLabelledTeamMember(
            lngLatLabelledAppUser,
            lngLatLabelledAppUser.lngLat
        )
    }

    useEffect(() => {
        if (selectedLngLatLabelledTeamMember) {
            mapFlyTo(selectedLngLatLabelledTeamMember.lngLat, false)
        }
    }, [selectedLngLatLabelledTeamMember])

    const markers = useMemo(() => {
        return teamMemberLocations.map((teamMemberLocation, index) => (
            <Marker
                key={index}
                longitude={teamMemberLocation.lngLat.lng}
                latitude={teamMemberLocation.lngLat.lat}
                onClick={() => onClick(teamMemberLocation)}
            >
                <LocationDot
                    diameter={40}
                    borderWidth={2}
                    backgroundColor={ColoursObj.backgrounds.primary}
                >
                    <MemberProfilePic
                        user={teamMemberLocation.object}
                        sideLength={40}
                    />
                </LocationDot>
            </Marker>
        ))
    }, [teamMemberLocations])

    return <>{markers}</>
}
